// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle-module--subtitle--g2GcG"};